import PageForm from '../form'

const TermsAndConditions = () => (
  <PageForm title="Terms and Conditions" Key="terms-&-conditions" />
)
export default TermsAndConditions
